import { KeyboardEvent } from "react";


export const onKeyDownHandlerCreator = (handleMapUpdate: ()=>void) => {
    return (e: KeyboardEvent<HTMLButtonElement>) => {
        if (e.key === "13") handleMapUpdate();
    };
};
